import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHConvenioDel = async (credentials, data) => {
    const body = {
        service: "RNHConvenioDel",
        params: {
            rnhConvenioId: data?.id || null,
            rnhConvenioVersion: data?.version ?? null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
